export function statusKind(status: string | null | undefined): 'ok' | 'warn' | 'err' | 'info' | 'neutral' {
  return status === 'running' ? 'info' : baseKind(status)
}

function baseKind(status: string | null | undefined): 'ok' | 'warn' | 'err' | 'info' | 'neutral' {
  switch (status) {
    case 'active':
    case 'succeeded':
    case 'transferred':
      return 'ok'
    case 'paused':
    case 'draft':
    case 'queued':
    case 'unchanged':
    case 'too_soon':
      return 'warn'
    case 'failed':
    case 'disabled':
      return 'err'
    case 'skipped':
    case 'cancelled':
      return 'neutral'
    default:
      return 'neutral'
  }
}

export function yesNo(v: boolean | null): string {
  return v === null ? 'not decided' : v ? 'yes' : 'no'
}

const fmt = new Intl.DateTimeFormat('sv-SE', { dateStyle: 'short', timeStyle: 'short', timeZone: 'Europe/Stockholm' })

export function dt(v: string | null | undefined): string {
  return v ? fmt.format(new Date(v)) : '–'
}

export function duration(seconds: number | null): string {
  if (seconds === null) return 'no limit'
  if (seconds % 86400 === 0) return `${seconds / 86400} d`
  if (seconds % 3600 === 0) return `${seconds / 3600} h`
  if (seconds % 60 === 0) return `${seconds / 60} min`
  return `${seconds} s`
}

const nf = new Intl.NumberFormat('sv-SE')

export function num(v: number | null | undefined): string {
  return v === null || v === undefined ? '–' : nf.format(v)
}

export function bytes(v: number | null | undefined): string {
  if (v === null || v === undefined) return '–'
  const units = ['B', 'kB', 'MB', 'GB', 'TB']
  let i = 0
  let n = v
  while (n >= 1000 && i < units.length - 1) {
    n /= 1000
    i++
  }
  return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
}

/** Elapsed time between two instants (or until `now`), e.g. "2 min 5 s". */
export function elapsed(from: string | null, to: string | null, now: number): string {
  if (!from) return '–'
  const s = Math.max(0, Math.round(((to ? new Date(to).getTime() : now) - new Date(from).getTime()) / 1000))
  if (s < 60) return `${s} s`
  if (s < 3600) return `${Math.floor(s / 60)} min ${s % 60} s`
  return `${Math.floor(s / 3600)} h ${Math.floor((s % 3600) / 60)} min`
}

/** One line describing a running run's live progress. */
export function progressText(p: Record<string, unknown> | null | undefined): string {
  if (!p) return ''
  const parts: string[] = []
  if (p.zone) parts.push(`.${String(p.zone)}`)
  if (p.step) parts.push(String(p.step).replace('_', ' '))
  if (p.input) parts.push(String(p.input))
  if (typeof p.object === 'number' && typeof p.of === 'number') parts.push(`object ${p.object}/${p.of}`)
  if (typeof p.statement === 'number' && typeof p.of === 'number') parts.push(`step ${p.statement}/${p.of}`)
  if (typeof p.records === 'number') parts.push(`${nf.format(p.records)} records`)
  if (typeof p.rows === 'number') parts.push(`${nf.format(p.rows)} rows`)
  if (p.table) parts.push(String(p.table))
  return parts.join(' · ')
}
